import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    class: "goods_box"
};
const _hoisted_2 = {
    key: 0,
    style: {
        "width": "800px"
    }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_button = _resolveComponent("el-button");
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_el_button_group = _resolveComponent("el-button-group");
    const _component_scTable = _resolveComponent("scTable");
    const _component_el_space = _resolveComponent("el-space");
    const _component_Goods = _resolveComponent("Goods");
    return _openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_space, {
                direction: "vertical",
                alignment: "flex-start"
            }, {
                default: _withCtx(()=>[
                        _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: $options.choose
                        }, {
                            default: _withCtx(()=>[
                                    ..._cache[1] || (_cache[1] = [
                                        _createTextVNode("服务商品", -1)
                                    ])
                                ]),
                            _: 1
                        }, 8, [
                            "onClick"
                        ]),
                        $data.value && $data.value.length !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_scTable, {
                                ref: "table",
                                data: $data.value,
                                stripe: "",
                                border: "",
                                showFlex: false,
                                hideDo: "",
                                hidePagination: "",
                                "row-key": "id"
                            }, {
                                default: _withCtx(()=>[
                                        _createVNode(_component_el_table_column, {
                                            label: "商品ID",
                                            prop: "id",
                                            width: "120",
                                            align: "center"
                                        }),
                                        _createVNode(_component_el_table_column, {
                                            label: "商品名称",
                                            prop: "title",
                                            align: "center",
                                            "min-width": "150"
                                        }),
                                        _createVNode(_component_el_table_column, {
                                            label: "商品售价",
                                            prop: "title",
                                            align: "center",
                                            "min-width": "150"
                                        }, {
                                            default: _withCtx(({ row })=>[
                                                    _createTextVNode(_toDisplayString(row.price == 0 ? "--" : `${"￥" + row.price}`), 1)
                                                ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                            label: "操作",
                                            align: "center",
                                            fixed: "right",
                                            width: "120"
                                        }, {
                                            default: _withCtx(({ row, $index })=>[
                                                    _createVNode(_component_el_button_group, null, {
                                                        default: _withCtx(()=>[
                                                                _createVNode(_component_el_button, {
                                                                    link: "",
                                                                    type: "primary",
                                                                    size: "small",
                                                                    onClick: ($event)=>$options.deleteData(row, $index)
                                                                }, {
                                                                    default: _withCtx(()=>[
                                                                            ..._cache[2] || (_cache[2] = [
                                                                                _createTextVNode("取消选择", -1)
                                                                            ])
                                                                        ]),
                                                                    _: 1
                                                                }, 8, [
                                                                    "onClick"
                                                                ])
                                                            ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                            _: 1
                                        })
                                    ]),
                                _: 1
                            }, 8, [
                                "data"
                            ])
                        ])) : _createCommentVNode("", true)
                    ]),
                _: 1
            })
        ]),
        $data.dialog.save ? (_openBlock(), _createBlock(_component_Goods, {
            key: 0,
            ref: "GoodsDialog",
            onSuccess: $options.handleSuccess,
            onClosed: _cache[0] || (_cache[0] = ($event)=>$data.dialog.save = false)
        }, null, 8, [
            "onSuccess"
        ])) : _createCommentVNode("", true)
    ], 64);
}
